import React from 'react';
import { Star } from 'lucide-react';

const ClientReview = ({ review }) => {
  if (!review) return null;

  return (
    <section className="rounded-lg border border-gray-200 bg-surface p-5 sm:p-6 shadow-sm">
      <div className="mb-4">
        <h2 className="text-base font-bold text-gray-900">Client review</h2>
        <p className="text-sm text-gray-500 mt-0.5">Feedback from this booking</p>
      </div>
      <div className="rounded-xl border border-gray-100 bg-surface-muted p-4">
        <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
          <div className="flex shrink-0">
            {[1, 2, 3, 4, 5].map((star) => (
              <Star
                key={star}
                className={`w-4 h-4 ${ star <= review.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300' }`}
              />
            ))}
          </div>
          {review.title ? (
            <span className="text-sm font-semibold text-gray-900 break-words">{review.title}</span>
          ) : null}
        </div>
        {review.comment ? (
          <p className="text-sm text-gray-600 leading-relaxed break-words">{review.comment}</p>
        ) : null}
        {!review.is_approved && (
          <p className="text-xs text-gray-500 italic mt-2">Pending approval</p>
        )}
      </div>
    </section>
  );
};

export default ClientReview;
